interface IBillingTableData {
  customer: string;
  customerLastName: string;
  amountDue: number;
  postmarkBy: string;
  billingAccountOrPolicyNumber: string;
}

interface IBillingDocument {
  firstName: string;
  lastName: string;
  minimumDueAmount: number;
  postmarkDate: string;
  billingAccountOrPolicyNumber: string;
}

export enum SortDirection {
  ascending = 'ascending',
  descending = 'descending',
  none = 'none',
}

export enum BillingSortableKeys {
  customerLastName = 'customerLastName',
  amountDue = 'amountDue',
  postmarkBy = 'postmarkBy',
  billingAccountOrPolicyNumber = 'billingAccountOrPolicyNumber',
  customer = "customer",
}

interface SortDirections {
  [BillingSortableKeys.customer]: SortDirection;
  [BillingSortableKeys.customerLastName]: SortDirection;
  [BillingSortableKeys.amountDue]: SortDirection;
  [BillingSortableKeys.postmarkBy]: SortDirection;
  [BillingSortableKeys.billingAccountOrPolicyNumber]: SortDirection;
}

export type { IBillingTableData, IBillingDocument, SortDirections };
